export const createObjectFromArray = (array) => ((array && Array.isArray(array)) ? array.reduce((ac, a) => ({ ...ac, [a]: "" }), {}) : {});
